export const privileges = {
    preview: 'PREVIEW',

    view_booking: 'VIEW_BOOKING',
    createBooking: 'CREATE_BOOKING',
    editBooking: 'EDIT_BOOKING',
    cloneBooking: 'COPY_BOOKING',
    cancelBooking: 'CANCEL_BOOKING',
    deleteBooking: 'DELETE_BOOKING',
    view_booking_list: 'VIEW_BOOKING_LIST',
    view_booking_event_source: 'VIEW_BOOKING_EVENT_SOURCE',
    assign_booking: 'ASSIGN_BOOKING',
    import_bookings: 'IMPORT_BOOKINGS',
    export_alif: 'EXPORT_ALIF',

    acceptPayment: 'ACCEPT_PAYMENT',
    manageLedgers: 'MANAGE_LEDGERS',
    process_refund: 'PROCESS_REFUND',

    add_actualization: 'ADD_ACTUALIZATION',
    finalize_actualization: 'FINALIZE_ACTUALIZATION',
    download_actualization: 'DOWNLOAD_ACTUALIZATION',
    add_ang_details: 'ADD_ANG_DETAILS',
    splitRevenue: 'SPLIT_REVENUE',
    post_bill: 'POST_BILL',
    void_bill: 'VOID_BILL',
    post_clear_tax: 'POST_CLEAR_TAX',

    view_beo: 'VIEW_BEO',
    add_beo: 'ADD_BEO',
    send_beo: 'SEND_BEO',
    preview_beo: 'PREVIEW_BEO',

    view_rfq: 'VIEW_REQUESTED_QUOTE',
    add_rfq: 'ADD_REQUESTED_QUOTE',
    edit_rfq: 'EDIT_REQUESTED_QUOTE',
    export_rfq: 'EXPORT_RFQS',
    delete_rfq: 'DELETE_REQUESTED_QUOTE',

    view_reports: 'VIEW_REPORTS',
    view_consolidated_reports: 'VIEW_CONSOLIDATED_REPORTS',

    view_user: 'VIEW_USER',
    add_user: 'ADD_USER',
    edit_user: 'EDIT_USER',
    delete_user: 'DELETE_USER',
    reset_password_user: 'RESET_PASSWORD_USER',
    block_user: 'BLOCK_USER',

    view_customer: 'VIEW_CUSTOMER',
    add_customer: 'ADD_CUSTOMER',
    edit_customer: 'EDIT_CUSTOMER',
    delete_customer: 'DELETE_CUSTOMER',
    reset_password_customer: 'RESET_PASSWORD_CUSTOMER',
    block_customer: 'BLOCK_CUSTOMER',
    export_customers: 'EXPORT_CUSTOMERS',

    view_agent: 'VIEW_AGENT',
    add_agent: 'ADD_AGENT',
    edit_agent: 'EDIT_AGENT',
    delete_agent: 'DELETE_AGENT',

    view_venue: 'VIEW_VENUE',
    add_venue: 'ADD_VENUE',
    edit_venue: 'EDIT_VENUE',
    delete_venue: 'DELETE_VENUE',

    view_venue_configuration: 'VIEW_VENUE_CONFIG',
    add_venue_configuration: 'ADD_VENUE_CONFIG',
    edit_venue_configuration: 'EDIT_VENUE_CONFIG',
    delete_venue_configuration: 'DELETE_VENUE_CONFIG',

    view_rooms: 'VIEW_ROOM',
    add_rooms: 'ADD_ROOM',
    edit_rooms: 'EDIT_ROOM',
    delete_rooms: 'DELETE_ROOM',

    view_budget: 'VIEW_BUDGET',
    add_budget: 'ADD_BUDGET',
    edit_budget: 'EDIT_BUDGET',
    delete_budget: 'DELETE_BUDGET',

    // Master Data Privileges
    view_addOn: 'VIEW_ADDON',
    add_addOn: 'ADD_ADDON',
    edit_addOn: 'EDIT_ADDON',
    delete_addOn: 'DELETE_ADDON',
    import_addOn: 'IMPORT_ADDONS',

    view_event_type: 'VIEW_EVENT_TYPE',
    add_event_type: 'ADD_EVENT_TYPE',
    edit_event_type: 'EDIT_EVENT_TYPE',
    delete_event_type: 'DELETE_EVENT_TYPE',

    view_venue_type: 'VIEW_VENUE_TYPE',
    add_venue_type: 'ADD_VENUE_TYPE',
    edit_venue_type: 'EDIT_VENUE_TYPE',
    delete_venue_type: 'DELETE_VENUE_TYPE',

    view_timeslot: 'VIEW_TIMESLOT',
    add_timeslot: 'ADD_TIMESLOT',
    edit_timeslot: 'EDIT_TIMESLOT',
    delete_timeslot: 'DELETE_TIMESLOT',

    view_price_package: 'VIEW_PRICE_PACKAGE',
    add_price_package: 'ADD_PRICE_PACKAGE',
    edit_price_package: 'EDIT_PRICE_PACKAGE',
    delete_price_package: 'DELETE_PRICE_PACKAGE',

    view_layout: 'VIEW_LAYOUT',
    add_layout: 'ADD_LAYOUT',
    edit_layout: 'EDIT_LAYOUT',
    delete_layout: 'DELETE_LAYOUT',

    view_location: 'VIEW_LOCATION',
    add_location: 'ADD_LOCATION',
    edit_location: 'EDIT_LOCATION',
    delete_location: 'DELETE_LOCATION',

    view_room_type: 'VIEW_ROOM_TYPE',
    add_room_type: 'ADD_ROOM_TYPE',
    edit_room_type: 'EDIT_ROOM_TYPE',
    delete_room_type: 'DELETE_ROOM_TYPE',

    view_meal_plan: 'VIEW_MEAL_PLAN',
    add_meal_plan: 'ADD_MEAL_PLAN',
    edit_meal_plan: 'EDIT_MEAL_PLAN',
    delete_meal_plan: 'DELETE_MEAL_PLAN',

    view_part_of_day: 'VIEW_PART_OF_DAY',
    add_part_of_day: 'ADD_PART_OF_DAY',
    edit_part_of_day: 'EDIT_PART_OF_DAY',
    delete_part_of_day: 'DELETE_PART_OF_DAY',

    view_tax_code: 'VIEW_TAXCODE',
    add_tax_code: 'ADD_TAXCODE',
    edit_tax_code: 'EDIT_TAXCODE',
    delete_tax_code: 'DELETE_TAXCODE',

    view_surcharge: 'VIEW_SURCHARGE',
    add_surcharge: 'ADD_SURCHARGE',
    edit_surcharge: 'EDIT_SURCHARGE',
    delete_surcharge: 'DELETE_SURCHARGE',

    view_industry_type: 'VIEW_INDUSTRY_TYPE',
    add_industry_type: 'ADD_INDUSTRY_TYPE',
    edit_industry_type: 'EDIT_INDUSTRY_TYPE',
    delete_industry_type: 'DELETE_INDUSTRY_TYPE',

    view_address: 'VIEW_COUNTY_STATE_CITY',
    add_address: 'ADD_COUNTY_STATE_CITY',
    edit_address: 'EDIT_COUNTY_STATE_CITY',
    delete_address: 'DELETE_COUNTY_STATE_CITY',
    import_address: 'IMPORT_COUNTRY_STATE_CITY',

    // Admin Controls
    view_parent_organization: 'VIEW_PARENT_ORG',
    edit_parent_organization: 'EDIT_PARENT_ORG',
    edit_theme: 'EDIT_THEME',

    view_org: 'VIEW_ORG',
    add_org: 'ADD_ORG',
    edit_org: 'EDIT_ORG',
    delete_org: 'DELETE_ORG',

    view_org_master_data: 'VIEW_ORG_MASTER_DATA',
    edit_org_master_data: 'EDIT_ORG_MASTER_DATA',

    view_role: 'VIEW_ROLE',
    add_role: 'ADD_ROLE',
    edit_role: 'EDIT_ROLE',
    delete_role: 'DELETE_ROLE',
    edit_privileges: 'EDIT_PRIVILEGES',

    view_payment_config: 'VIEW_PAYMENT_CONFIGURATION',
    add_payment_config: 'ADD_PAYMENT_CONFIGURATION',
    edit_payment_config: 'EDIT_PAYMENT_CONFIGURATION',
    delete_payment_config: 'DELETE_PAYMENT_CONFIGURATION',

    view_template_schedule: 'VIEW_TEMPLATE_SCHEDULE',
    edit_template_schedule: 'EDIT_TEMPLATE_SCHEDULE',

    view_mail_template: 'VIEW_MAIL_TEMPLATE',
    edit_mail_template: 'EDIT_MAIL_TEMPLATE',

    view_email_event_config: 'VIEW_EMAIL_EVENT_CONFIG',
    add_email_event_config: 'ADD_EMAIL_EVENT_CONFIG',
    edit_email_event_config: 'EDIT_EMAIL_EVENT_CONFIG',
    delete_email_event_config: 'DELETE_EMAIL_EVENT_CONFIG',

    view_email_server_config: 'VIEW_MAIL_SERVER_CONFIG',
    edit_email_server_config: 'EDIT_MAIL_SERVER_CONFIG',

    view_booking_message: 'VIEW_BOOKING_MSG',
    edit_booking_message: 'EDIT_BOOKING_MSG',

    view_system_message: 'VIEW_SYSTEM_MSG',
    edit_system_message: 'EDIT_SYSTEM_MSG',

    view_add_on_categories: 'VIEW_ADD_ON_CATEGORY',
    add_add_on_categories: 'ADD_ADD_ON_CATEGORY',
    edit_add_on_categories: 'EDIT_ADD_ON_CATEGORY',
    delete_add_on_categories: 'DELETE_ADD_ON_CATEGORY',

    view_payment_methods: 'VIEW_PAYMENT_METHODS',
    add_payment_methods: 'ADD_PAYMENT_METHODS',
    edit_payment_methods: 'EDIT_PAYMENT_METHODS',
    delete_payment_methods: 'DELETE_PAYMENT_METHODS',

    // Sales Management- related privileges
    view_company_master: 'SALES_VIEW_COMPANY_MASTER',
    add_company_master: 'SALES_ADD_COMPANY_MASTER',
    edit_company_master: 'SALES_EDIT_COMPANY_MASTER',
    delete_company_master: 'SALES_DELETE_COMPANY_MASTER',

    view_sales_call: 'SALES_VIEW_CALL_DETAILS',
    add_sales_call: 'SALES_ADD_CALL_DETAILS',
    edit_sales_call: 'SALES_EDIT_CALL_DETAILS',
    delete_sales_call: 'SALES_DELETE_CALL_DETAILS',

    view_sales_report: 'SALES_REPORT',

    ids_configs: 'IDS_CONFIGS',
};
